import { render } from "./WhoWeHelped.vue?vue&type=template&id=5c3666cc&scoped=true"
import script from "./WhoWeHelped.vue?vue&type=script&lang=js"
export * from "./WhoWeHelped.vue?vue&type=script&lang=js"

import "./WhoWeHelped.vue?vue&type=style&index=0&id=5c3666cc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c3666cc"]])

export default __exports__